import React from "react";
import { RouteProps } from "react-router-dom";

import {
  Home,
  Login,
  Termos,
  PrimeiroAcesso,
  Dados,
  ListarParticipantes,
  Contracheque,
  ContrachequeDetalhe,
  Relacionamento,
  EsqueciSenha,
  TrocarSenha,
  Emprestimos,
  EmprestimoDetalhe,
  Extrato,
  InformeRendimentos,
  SimuladorAposentadoria,
  Resultado,
  Documentos,
  SelecionarMatricula,
  ExtratoAssistido,
  EmprestimoSimulador,
  EmprestimoSimuladorPrestacoes,
  EmprestimoSimuladorResumo,
  Recadastramento,
  Comprovantes,
  ComprovanteDetalhe,
} from "@screens";
import {
  FaHome,
  FaBriefcase,
  FaSignOutAlt,
  FaBookmark,
  FaChartLine,
  FaQuestion,
  FaClosedCaptioning,
  FaUser,
  FaChartPie,
  FaEnvelope,
  FaKey,
  FaHandshake,
  FaFile,
  FaFileAlt,
  FaMoneyBillWave,
  FaMoneyCheck,
  FaSyncAlt,
  FaThumbsUp,
  FaHandHoldingUsd,
  FaAddressCard,
  FaClipboard,
} from "react-icons/fa";
import { EmprestimoSimuladorProvider } from "@src/contexts";

export const routes = [
  {
    id: "home",
    path: "/",
    title: "Página Inicial",
    component: (routeProps: RouteProps) => <Home {...routeProps} />,
    icon: <FaHome />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "dados",
    path: "/dados",
    title: "Seus Dados",
    component: (routeProps: RouteProps) => <Dados {...routeProps} />,
    icon: <FaUser />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "extrato",
    path: "/extrato",
    title: "Extrato",
    component: (routeProps: RouteProps) => <Extrato {...routeProps} />,
    icon: <FaFileAlt />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "extratoAssistido",
    path: "/extratoAssistido",
    title: "Extrato do Assistido",
    component: (routeProps: RouteProps) => <ExtratoAssistido {...routeProps} />,
    icon: <FaMoneyCheck />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "contracheque",
    path: "/contracheque",
    title: "Contracheque",
    component: (routeProps: RouteProps) => <Contracheque {...routeProps} />,
    icon: <FaClosedCaptioning />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "contrachequeDetalhe",
    path: "/contrachequeDetalhe/:plano/:data/:cdTipoFolha/:cdEspecie/:previa?",
    linkPath: "/contrachequeDetalhe",
    title: "Contracheque Detalhe",
    component: (routeProps: RouteProps) => <ContrachequeDetalhe {...routeProps} />,
    icon: <FaClosedCaptioning />,
    exactPath: true,
    showInMenu: false,
  },
  {
    id: "emprestimos",
    path: "/emprestimos",
    title: "Empréstimos",
    component: (routeProps: RouteProps) => <Emprestimos {...routeProps} />,
    icon: <FaHandshake />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "emprestimos",
    path: "/emprestimoDetalhe/:numero/:ano",
    linkPath: "/emprestimoDetalhe",
    title: "Empréstimos - Detalhe",
    component: (routeProps: RouteProps) => <EmprestimoDetalhe {...routeProps} />,
    icon: <FaHandshake />,
    exactPath: true,
    showInMenu: false,
  },
  // {
  //   id: "emprestimoSimulador",
  //   path: "/emprestimoSimulador",
  //   title: "Simulador de Empréstimos",
  //   component: (routeProps: RouteProps) => <EmprestimoSimulador {...routeProps} />,
  //   icon: <FaHandHoldingUsd />,
  //   exactPath: true,
  //   showInMenu: false,
  // },
  // {
  //   id: "emprestimoSimuladorPrestacoes",
  //   path: "/emprestimosSimuladorPrestacoes",
  //   title: "Simulador de Empréstimos - Prestações",
  //   component: (routeProps: RouteProps) => <EmprestimoSimuladorPrestacoes {...routeProps} />,
  //   icon: <FaHandHoldingUsd />,
  //   exactPath: true,
  //   showInMenu: false,
  // },
  // {
  //   id: "emprestimoSimuladorResumo",
  //   path: "/emprestimosSimuladorResumo",
  //   title: "Simulador de Empréstimos - Resumo",
  //   component: (routeProps: RouteProps) => <EmprestimoSimuladorResumo {...routeProps} />,
  //   icon: <FaHandHoldingUsd />,
  //   exactPath: true,
  //   showInMenu: false,
  // },
  {
    id: "simuladorAposentadoria",
    path: "/simuladorAposentadoria",
    title: "Simulador Aposentadoria",
    component: (routeProps: RouteProps) => <SimuladorAposentadoria {...routeProps} />,
    icon: <FaMoneyBillWave />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "simuladorAposentadoriaResultado",
    path: "/simuladorAposentadoria/resultado/:idadeAposentadoria/:rentabilidadeAnual/:mesesPrazo/:percentualResgate/:contribuicaoAdicional",
    linkPath: "/simuladorAposentadoria/resultado/",
    title: "Simulador Aposentadoria",
    component: (routeProps: RouteProps) => <Resultado {...routeProps} />,
    icon: <FaMoneyBillWave />,
    exactPath: true,
    showInMenu: false,
  },
  {
    id: "informeRendimentos",
    path: "/infoRend",
    title: "Informe de Rendimentos",
    component: (routeProps: RouteProps) => <InformeRendimentos {...routeProps} />,
    icon: <FaChartPie />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "recadastramento",
    path: "/recadastramento",
    title: "Recadastramento",
    component: (routeProps: RouteProps) => <Recadastramento {...routeProps} />,
    icon: <FaAddressCard />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "comprovantes",
    title: "Comprovantes",
    icon: <FaClipboard />,
    path: "/comprovantes",
    component: (routeProps: RouteProps) => <Comprovantes {...routeProps} />,
    showInMenu: true,
    exactPath: true,
  },
  {
    id: "comprovantesDetalhe",
    title: "Comprovante",
    icon: <FaClipboard />,
    path: "/comprovantesDetalhe/:oid",
    linkPath: "/comprovantesDetalhe",
    component: (routeProps: RouteProps) => <ComprovanteDetalhe {...routeProps} />,
    showInMenu: false,
    exactPath: true,
  },
  {
    id: "documentos",
    path: "/documentos/:pasta?",
    linkPath: "/documentos/",
    title: "Documentos",
    icon: <FaFile />,
    component: (routeProps: RouteProps) => <Documentos {...routeProps} />,
    showInMenu: false,
  },
  {
    id: "documentos",
    path: "/documentos",
    title: "Documentos",
    icon: <FaFile />,
    component: (routeProps: RouteProps) => <Documentos {...routeProps} />,
    showInMenu: true,
  },
  {
    id: "relacionamento",
    path: "/relacionamento",
    title: "Fale Conosco",
    component: (routeProps: RouteProps) => <Relacionamento {...routeProps} />,
    icon: <FaEnvelope />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "trocarSenha",
    path: "/trocarSenha",
    title: "Trocar Senha",
    component: (routeProps: RouteProps) => <TrocarSenha {...routeProps} />,
    icon: <FaKey />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "selecionarMatricula",
    path: "/selecionarMatricula",
    title: "Selecionar Matrícula",
    icon: <FaSyncAlt />,
    component: (routeProps: RouteProps) => <SelecionarMatricula {...routeProps} />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "esqueciSenha",
    path: "/esqueciSenha",
    title: "Esqueci Minha Senha",
    component: (routeProps: RouteProps) => <EsqueciSenha {...routeProps} />,
    icon: <FaQuestion />,
    exactPath: true,
    showInMenu: false,
  },
  {
    id: "termos",
    path: "/termos",
    title: "Termos LGPD",
    component: (routeProps: RouteProps) => <Termos {...routeProps} />,
    icon: <FaThumbsUp />,
    exactPath: true,
    showInMenu: true,
  },
  {
    id: "primeiroAcesso",
    path: "/primeiroAcesso",
    title: "Primeiro Acesso",
    component: (routeProps: RouteProps) => <PrimeiroAcesso {...routeProps} />,
    exactPath: true,
    showInMenu: false,
  },
  {
    id: "ListarParticipantes",
    path: "/ListarParticipantes",
    title: "Listagem de Participantes",
    component: (routeProps: RouteProps) => <ListarParticipantes {...routeProps} />,
    exactPath: true,
    showInMenu: false,
  },
  {
    id: "login",
    path: "/login",
    title: "Sair",
    component: (routeProps: RouteProps) => <Login {...routeProps} />,
    icon: <FaSignOutAlt />,
    exactPath: true,
    showInMenu: true,
  },
];
